<template>
    <validation-observer ref="guest_credit_modal" v-slot="{ meta,errors, validate }">
        <modal
            :id="modalId"
            title="Guest Credit"
            scrollable
            size="lg"
            ok-title="Apply"
            @show="fetchData"
            @hidden="resetState"
            :ok-disabled="!meta.valid"
            @ok.prevent="guestCredit"
            @shown="validate()"
        >
            <busy-modal :show="loading"></busy-modal>
            <b-row>
                <b-col>
                    <form-select
                        floating-label="Payment Method"
                        v-model="paymentMethod"
                        :options="paymentMethodOptions"
                        :disabled="true"
                    ></form-select>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <validation-provider name="selectedCreditCode"  rules="required">
                        <form-select
                            v-model="selectedCreditCode"
                            floatingLabel="Code"
                            :options="creditCodeOptions"
                            @input="onCodeChange"
                            :error="errors.selectedCreditCode"
                        />
                    </validation-provider>
                </b-col>
            </b-row>
            <b-row v-if="guestName">
                <b-col>
                    <form-input floating-label="Guest Name" v-model="guestName" :disabled="true" />
                </b-col>
            </b-row>
            <b-row v-if="created">
                <b-col>
                    <form-datepicker
                        v-model="created"
                        floating-label="Created"
                        :display-format="userUnicodeDateFormat"
                        :hide-header="true"
                        :reset-button="true"
                        :disabled="true"
                    />
                </b-col>
            </b-row>
            <b-row v-if="amount">
                <b-col>
                    <form-input floating-label="Amount" v-model="amount" type="number" :disabled="true" />
                </b-col>
            </b-row>
        </modal>
    </validation-observer>
</template>

<script>
import { mapGetters } from 'vuex';
import API from '../../../../../api.jsx';
import Modal from '../../../../generic/modal/modal.vue';
import BusyModal from '../../../../generic/busy-modal/busy-modal.vue';
import FormInput from '../../../../generic/form-input/form-input.vue';
import FormSelect from '../../../../generic/form-select/form-select.vue';
import FormDatepicker from '../../../../generic/form-datepicker/form-datepicker.vue';
import {
    GUEST_RESERVATION_GUEST_CREDITS_ENDPOINT,
    GUEST_RESERVATION_APPLY_GUEST_CREDIT_ENDPOINT,
} from '../../../../../endpoints';

export default {
    name: 'GuestCreditModal',
    components: { Modal, BusyModal, FormInput, FormSelect, FormDatepicker },
    props: {
        modalId: String,
        reservation: Object,
        onUpdate: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            loading: false,
            guestName: null,
            created: null,
            amount: null,
            selectedCreditCode: null,
            creditCodeOptions: [],
            paymentMethodOptions: [{ value: 14, text: 'Guest Credit' }],
            paymentMethod: 14,
        };
    },
    inject: ['showSuccessToast', 'showErrorToast'],
    computed: {
        ...mapGetters('header', ['userUnicodeDateFormat']),
    },
    methods: {
        onCodeChange(code) {
            const selectedCode = this.creditCodeOptions.find((c) => c.value == code);
            if (selectedCode) {
                this.guestName = selectedCode.guest_name;
                this.created = selectedCode.created;
                this.amount = selectedCode.amount;
            }
            this.$refs.guest_credit_modal.setFieldValue('selectedCreditCode', code);
        },
        resetState() {
            this.guestName = null;
            this.created = null;
            this.amount = null;
            this.selectedCreditCode = null;
        },
        async fetchData() {
            try {
                const { data } = await API.get(
                    GUEST_RESERVATION_GUEST_CREDITS_ENDPOINT(this.reservation.id, this.reservation.user.id)
                );
                this.creditCodeOptions = [
                    {
                        value: null,
                        text: '-- Select Credit Code --',
                        disabled: true,
                    },
                ].concat(data);
            } catch (err) {
                this.showErrorToast({
                    text: 'Could not fetch code options.',
                });
            }
        },
        async guestCredit() {
            try {
                this.loading = true;
                await API.post(
                    GUEST_RESERVATION_APPLY_GUEST_CREDIT_ENDPOINT(this.reservation.id, this.reservation.user.id),
                    { code: this.selectedCreditCode }
                );
                this.$bvModal.hide(this.modalId);
                this.onUpdate();
                this.showSuccessToast({
                    text: 'Guest Credit successfully applied.',
                });
            } catch (err) {
                const { generic } = formatResponseError(err);
                this.showErrorToast({
                    text: generic || 'Could not apply guest credit.',
                });
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
